import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';

interface LandingScreenProps {
  onComplete?: () => void;
  duration?: number;
}

const LandingScreen: React.FC<LandingScreenProps> = ({
  onComplete,
  duration = 3000
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onComplete?.();
      }, 800);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: 'easeInOut' }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              width: '100vw',
              height: '100vh',
              backgroundColor: '#000000',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <motion.img
              src="/logo_2.png"
              alt="BlueCat Logo"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 1,
                ease: 'easeOut',
                delay: 0.3
              }}
              style={{
                maxWidth: '150px',
                maxHeight: '150px',
                objectFit: 'contain',
              }}
            />

            {/* Progress Bar Container */}
            <Box
              sx={{
                width: '200px',
                height: '2px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '1px',
                marginTop: '40px',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              {/* Animated Progress Bar */}
              <motion.div
                initial={{ width: '0%' }}
                animate={{ width: '100%' }}
                transition={{
                  duration: (duration - 500) / 1000,
                  ease: 'easeInOut',
                  delay: 0.5,
                }}
                style={{
                  height: '100%',
                  background: 'linear-gradient(90deg, #3b82f6, #60a5fa)',
                  borderRadius: '1px',
                  boxShadow: '0 0 10px #3b82f6, 0 0 20px #3b82f6, 0 0 30px #3b82f6',
                }}
              />
            </Box>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LandingScreen;
